import { render, staticRenderFns } from "./ChannelOrderInfo.vue?vue&type=template&id=890d465e&scoped=true&"
import script from "./ChannelOrderInfo.vue?vue&type=script&lang=js&"
export * from "./ChannelOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChannelOrderInfo.vue?vue&type=style&index=0&id=890d465e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890d465e",
  null
  
)

export default component.exports